import React from 'react';

interface HandsIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Manos sosteniendo paquete"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Dos manos abiertas sosteniendo un paquete
 * - Manos con dedos extendidos en posición de sostener
 * - Paquete rectangular con cinta/etiqueta
 * - Representa manipulación manual de productos
 * - Estilo minimalista, líneas limpias
 * - Simboliza el proceso de preparación manual de pedidos
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const HandsIcon: React.FC<HandsIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={(size * 134) / 150}
      viewBox="0 0 150 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M58.3333 4.65625V35.8281C58.3333 36.5814 58.724 37.2568 59.375 37.6205C60.026 37.9842 60.8073 37.9842 61.4583 37.6205L75 29.9055L88.5417 37.6205C89.1927 37.9842 89.974 37.9842 90.625 37.6205C91.276 37.2568 91.6667 36.5555 91.6667 35.8281V4.65625H104.167C108.776 4.65625 112.5 8.3709 112.5 12.9688V54.5312C112.5 59.1291 108.776 62.8438 104.167 62.8438H45.8333C41.224 62.8438 37.5 59.1291 37.5 54.5312V12.9688C37.5 8.3709 41.224 4.65625 45.8333 4.65625H58.3333ZM60.4167 0.5H45.8333C38.9323 0.5 33.3333 6.08496 33.3333 12.9688V54.5312C33.3333 61.415 38.9323 67 45.8333 67H104.167C111.068 67 116.667 61.415 116.667 54.5312V12.9688C116.667 6.08496 111.068 0.5 104.167 0.5H60.4167ZM62.5 4.65625H87.5V32.2434L76.0417 25.6973C75.3906 25.3336 74.6094 25.3336 73.9844 25.6973L62.5 32.2434V4.65625ZM48.8021 83.625C45.1042 83.625 41.4844 84.716 38.4115 86.7682L18.125 100.25H2.08333C0.9375 100.25 0 101.185 0 102.328C0 103.471 0.9375 104.406 2.08333 104.406H18.75C19.1667 104.406 19.5573 104.276 19.8958 104.069L40.7031 90.223C43.099 88.6385 45.9115 87.7812 48.8021 87.7812H87.5C92.1094 87.7812 95.8333 91.4959 95.8333 96.0938C95.8333 100.692 92.1094 104.406 87.5 104.406H64.5833C63.4375 104.406 62.5 105.341 62.5 106.484C62.5 107.627 63.4375 108.562 64.5833 108.562H103.281C103.672 108.562 104.089 108.459 104.401 108.225L134.141 89.0022C135.365 88.2229 136.823 87.7812 138.281 87.7812C142.422 87.7812 145.833 91.1322 145.833 95.2105C145.833 97.6783 144.609 99.9643 142.578 101.367L107.292 125.369C103.49 127.967 98.9844 129.344 94.375 129.344H2.08333C0.9375 129.344 0 130.279 0 131.422C0 132.565 0.9375 133.5 2.08333 133.5H94.375C99.8177 133.5 105.13 131.863 109.635 128.798L144.922 104.796C148.099 102.64 150 99.0551 150 95.2105C150 88.7943 144.688 83.625 138.281 83.625C136.016 83.625 133.776 84.2744 131.875 85.4953L102.656 104.406H96.8229C98.8021 102.198 100 99.2889 100 96.0938C100 89.21 94.401 83.625 87.5 83.625H48.8021Z" fill="currentColor"/>
    </svg>
  );
};
